// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AliyunOutlinedSvg from "@fishx/icons-svg/es/asn/AliyunOutlined";
import FishxIcon from '../components/FishxIcon';

var AliyunOutlined = function AliyunOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AliyunOutlinedSvg
  }));
};

AliyunOutlined.displayName = 'AliyunOutlined';
export default React.forwardRef(AliyunOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AliyunOutlined.js
// module id = 1973
// module chunks = 0